import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import AnnouncementsHeader from '@client/pages/landingPage/announcementsPage/announcementsHeader/AnnouncementsHeader';
import StepByStep from '@client/pages/landingPage/announcementsPage/stepByStep/StepByStep';
import Contact from '@client/pages/landingPage/announcementsPage/contact/Contact';
import PageHelmet from '@client/components/pageHelmet/PageHelmet';
import styles from './announcementsPage.scss';

function AnnouncementsPage() {
  const { t } = useTranslation(['metadata']);
  const contactRef = useRef(null);

  const navigateToContactRef = () => {
    contactRef.current.scrollIntoView();
  };
  return (
    <article className={styles.announcementsPage}>
      <div className={styles.announcementsPageContent}>
        <AnnouncementsHeader onContactClick={navigateToContactRef} />
        <StepByStep />
        <Contact inputRef={contactRef} />
      </div>
      <PageHelmet
        title={t('metadata:advertiser.title')}
        description={t('metadata:advertiser.description')}
      />
    </article>
  );
}

AnnouncementsPage.propTypes = {};

export default AnnouncementsPage;
